import { render, staticRenderFns } from "./quarter.vue?vue&type=template&id=525c8134&scoped=true"
import script from "./quarter.vue?vue&type=script&lang=js"
export * from "./quarter.vue?vue&type=script&lang=js"
import style0 from "./quarter.vue?vue&type=style&index=0&id=525c8134&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525c8134",
  null
  
)

export default component.exports